import React from 'react';

import { useFormSubmit } from '@occc-app/hooks/useFormSubmit';

import CreateProductGroup from './CreateProductGroupPage';
import { createProductGroupFormId } from './CreateProductGroupFormContainer';

const CreateProductGroupPageContainer: React.FC = () => {
  const submitCreateProductGroupForm = useFormSubmit(createProductGroupFormId);

  return <CreateProductGroup submitCreateProductGroupForm={submitCreateProductGroupForm} />;
};

export default CreateProductGroupPageContainer;
